<template>
    <div id="candidates" class="page-layout__inner">
        <!--Filter-->
        <div :class="filterParameters.visibility ? 'page-layout__filter' : ''">
            <section :class="'section  section--shadow-0  section--p-0' + (filterParameters.visibility ? ' h-100' : '')">
                <button @click="filterParameters.visibility = true" :class="'section__filter-btn' + (filterParameters.visibility ? ' section__filter-btn--hidden' : '')">
                    <svg class="section__filter-icon">
                        <use xlink:href="#icon__filter"></use>
                    </svg>
                </button>
                <div :class="'section__filter' + (filterParameters.visibility ? '' : ' section__filter--hidden')">
                    <div class="section__header">
                        <h3 class="section__title">
                            <svg class="section__filter-icon">
                                <use xlink:href="#icon__filter"></use>
                            </svg>
                            {{ getTranslation('filter') }}
                        </h3>

                        <div class="section__controls">
                            <div class="section__controls-group">
                                <a @click="filterParameters.visibility = false" class="btn  btn--xs  btn--control  js-filterHider" href="javascript:void(0)">{{ getTranslation('hide') }}</a>
                                <a class="btn  btn--xs  btn--control" @click="resetFilter" href="javascript:void(0)">{{ getTranslation('reset') }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="section__body">
                        <div class="form__group">
                            <label for="by-pin-snp" class="form__label  form__label--block">{{ getTranslation('searchByfioPin') }}</label>
                            <div class="field-advanced">
                                <form method="post" @submit.prevent="() => {filterForm.page=1;fetchCandidates()}">
                                    <div class="field-advanced__inner">
                                        <div class="field-advanced__field-wrap">
                                            <input id="by-pin-snp" v-model="filterForm.query" :placeholder="getTranslation('searchByfioPin')"
                                                   class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text">
                                        </div>

                                        <div class="field-advanced__right">
                                            <button class="btn  btn--square  btn--main">
                                                <svg class="btn__icon">
                                                    <use xlink:href="#icon__search"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="checkbox-group  form__group" v-if="filterResource.genders.length > 0">
                            <div class="checkbox-group__label  checkbox-group__label--block">
                                <span class="collapse-btn__text">{{ getTranslation('gender') }}</span>
                            </div>

                            <label class="checkbox">
                                <input @click="$event.target.value ? filterForm.gender = '' : null" v-model="filterForm.gender" :value="filterResource.genders[0].id" class="checkbox__input" type="radio">
                                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                                <span class="checkbox__label">{{ filterResource.genders[0].title }}</span>
                            </label>

                            <label class="checkbox">
                                <input @click="$event.target.value ? filterForm.gender = '' : null" v-model="filterForm.gender" :value="filterResource.genders[1].id" class="checkbox__input" type="radio">
                                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                                <span class="checkbox__label">{{ filterResource.genders[1].title }}</span>
                            </label>
                        </div>
                        <div class="form__group">
                            <label class="form__label  form__label--block">{{ getTranslation('byAge') }}</label>
                            <div class="pr-3 pl-3 mt-5">
                                <range-slider :min="0"
                                              :max="100"
                                              :interval="1"
                                              v-model="filterForm.age"
                                              :dot-options="[{tooltip: 'always'}, {tooltip: 'always'}]"
                                              tooltip-formatter="{value}"
                                              @drag-end="() => {filterForm.page=1;fetchCandidates()}"
                                ></range-slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <!--candidates list-->
        <div class="page-layout__content">
            <p class="page-layout__descr  text">{{ getTranslation('foundWithQuantity',pagination.total) }}</p>
            <div v-if="pagination.total">
                <div class="page-layout__group">
                    <section class="section">
                        <div class="section__header  flex-nowrap  align-items-start">
                            <h3 class="section__title"></h3>
                            <div class="section__controls">
                                <div class="section__controls-group"></div>
                            </div>
                        </div>
                        <div class="section__body">
                            <table class="table  table--noborder">
                                <thead class="table__head">
                                    <tr class="table__row">
                                        <th class="table__cell  table__hcell" style="width: 30%;">{{ getTranslation('candidate') }}</th>
                                        <th class="table__cell  table__hcell" style="width: 20%;">{{ getTranslation('email') }}</th>
                                        <th class="table__cell  table__hcell" style="width: 20%;"></th>
                                        <th class="table__cell  table__hcell" style="width: 5%;"></th>
                                    </tr>
                                </thead>
                                <tbody class="table__body">
                                    <tr v-for="item in items" v-bind:key="item.id" class="table__row">
                                        <td class="table__cell">
                                            <!-- PERSON -->
                                            <div class="person">
                                                <div class="person__inner">
                                                    <div class="person__img" :class="{'person__img--online':item.isOnline,'person__img--offline':!item.isOnline}">
                                                        <img style="height:48px;" :src="item.photoUrl || $config.noAvatarUrl" />
                                                    </div>

                                                    <div class="person__info">
                                                        <h3 class="person__name">
                                                            <router-link class="person__link" :to="{ name: 'api.candidate.get', params: { id: item.id } }">
                                                                {{ item.fullName }}
                                                            </router-link>
                                                            <br />
                                                        </h3>
                                                        <div class="person__descr">
                                                            {{ item.bdate }} ({{ item.age }})
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- / PERSON -->
                                        </td>
                                        <td class="table__cell">
                                            {{ item.email }}
                                        </td>
                                        <td class="table__cell"></td>
                                        <td class="table__cell">
                                            <ActionsComponent />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
                <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
                    <pagination :pagination="pagination" @change="()=>{fetchCandidates();this.$scrollTo('#candidates');}" v-model="filterForm.page"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                filterForm: {
                    age: [0, 100],
                    gender: ''
                },
                filterResource: {
                    genders: []
                },
                pagination: {
                    total: '',
                    lastPage: '',
                    currentPage: ''
                },
                items: [],
                filterParameters: {
                    visibility: true,
                    loadSelects: false
                },
            }
        },
        watch: {
            'filterForm.age'( age ) {
                if ( age && isNaN( age ) ) this.filterForm.age.max = '';
            },

            'filterForm.age.min'( age ) {
                if ( age && isNaN( age ) ) this.filterForm.age.min = '';
            },
            'filterForm.gender'() {
                this.fetchCandidates();
            }
        },
        updated() {
            this.setHeadings( {
                title: this.getTranslation( 'candidates' )
            } );
        },
        created() {
            this.fetchCandidates();
            this.fetchFilterOptions();
        },
        methods: {
            fetchCandidates() {
                let params = this.cleanObject( { ...this.filterForm } );
                return this.axios.get( this.$config.urls.candidate.fetchCandidates.url, { params: params } )
                           .then( response => {
                               this.items = response.data.data.items;
                               this.pagination.currentPage = response.data.data.activePage;
                               this.filterForm.page = response.data.data.activePage;
                               this.pagination.total = response.data.data.totalItemsCount;
                               this.pagination.lastPage = response.data.data.pages;
                               this.$router.replace( { query: params } ).catch( () => {
                               } );
                           } ).catch(()=>{});
            },
            fetchFilterOptions() {
                this.axios.get( this.$config.urls.candidate.filterOptions.url )
                    .then( response => {
                        this.filterResource.genders = this.objectToArray( response.data.data.genders, true, true );
                    } ).catch(()=>{});
            },

            resetFilter() {

            }
        }
    }
</script>

<style scoped>

</style>
